<template>
  <div class="signature-report-real-container">
    <div class="head-box">
      <div class="head-content">
        <span class="icon_i">i</span>
        <span class="block">
          由于运营商政策管控，签名需要进行实名制报备，报备时效为T+2，报备后以实际测试接收情况为准！</span
        >
      </div>
    </div>
    <div class="signature-report-real-content">
      <div class="btn-box">
        <el-button type="primary" @click="onAddReport(null, 'add')"
          >新增报备</el-button
        >
        <div class="btn-tip">温馨提示：官方及运营商预计7个工作日内完成审核，请耐心等待！</div>
      </div>
      <div class="new-table-box">
        <el-table
          v-loading="tableLoading"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="light"
          :header-cell-style="{
            background: '#fafafa',
            'text-align': 'left',
            height: '48px',
          }"
          :cell-style="{ 'text-align': 'left' }"
          style="width: 100%; opacity: 1"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column prop="signature" label="签名"></el-table-column>
          <el-table-column prop="companyName" label="公司名"></el-table-column>
          <el-table-column
            prop="creditCode"
            label="统一社会信用代码"
          ></el-table-column>
          <el-table-column
            prop="chaosLegalPersonName"
            label="主体公司法人姓名"
          ></el-table-column>
          <el-table-column
            prop="chaosLegalPersonIdCard"
            label="法人身份证号"
          ></el-table-column>
          <el-table-column prop="chaosHandlerName" label="经办人"></el-table-column>
          <el-table-column
            prop="chaosHandlerIdCard"
            label="经办人身份证号"
          ></el-table-column>
          <el-table-column
            prop="chaosHandlerMobile"
            label="经办人手机号"
          >
          <template slot-scope="scope">
              <span style="user-select:none;">{{ scope.row.chaosHandlerMobile }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="smsContent" label="短信内容示例" width="200px">
            <template slot="header" slot-scope="scope">
              <span>短信内容示例</span>
              <span
                v-if="!allShow"
                class="header-row-tip"
                @click="allShow = true"
                >展开全部
                <div class="new-down-icon-box" style="margin: -3px 0"></div>
              </span>
              <span
                v-if="allShow"
                class="header-row-tip"
                @click="allShow = false"
                >收起全部
                <div class="new-top-icon-box" style="margin: -3px 0"></div>
              </span>
            </template>
            <template slot-scope="scope">
              <div>
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="scope.row.smsContent || '-'"
                  placement="top"
                >
                  <div
                    class="hoveTitle"
                    v-show="!allShow"
                    @click="showMediaInfo(scope.row)"
                  >
                    {{ scope.row.smsContent || '-'}}
                  </div>
                </el-tooltip>
                <div
                  class="hoveTitleShowMore"
                  v-show="allShow"
                  @click="showMediaInfo(scope.row)"
                >
                  {{ scope.row.smsContent || '-'}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="创建时间" width="180px"></el-table-column>
          <el-table-column prop="reportStatus" label="报备状态">
            <template slot-scope="scope">
              {{ statusMap[scope.row.reportStatus] || "--" }}
              <!-- 拒绝时有拒绝原因 -->
              <el-tooltip
                v-if="scope.row.reportStatus==4 || scope.row.reportStatus==5"
                class="item"
                effect="light"
                :content="scope.row.failMessage"
                placement="top"
              >
                <i
                  class="el-icon-question"
                  style="color: #ccc; cursor: pointer"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="bindDate" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="margin-right: 8px;width: 32px;"
                @click="onAddReport(scope.row, 'copy')"
                >复制</el-button
              >
              <!-- 未提交 || 拒绝状态可编辑 -->
              <el-button
                v-if="[0,4,5].includes(scope.row.reportStatus)"
                type="text"
                style="margin-right: 8px;width: 32px;"
                @click="onAddReport(scope.row, 'edit')"
                >编辑</el-button
              >
              <!-- 未提交 || 拒绝状态 -->
              <el-button v-if="[0,4,5].includes(scope.row.reportStatus)" type="text" style="width: 32px;" @click="onDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="text-align: right; margin-top: 20px; margin-right: 120px"
          @size-change="handlePageChange($event, 'size')"
          @current-change="handlePageChange($event, 'cur')"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="pageInfo.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page="pageInfo.current"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增，编辑 -->
    <AddRealReport
      v-model="isShowAdd"
      :controlType="controlType"
      :rowData="rowData"
      @update="getList"
    />
  </div>
</template>

<script>
import AddRealReport from "./components/AddRealReport.vue";
import { getReportRecord , deleteReportRecord } from "@/api/backstage/messageBill";

/**
 * 实时报备
 */
export default {
  name: "signature_report_real",
  components: {
    AddRealReport,
  },
  data() {
    return {
      tableLoading: false,
      tableData: [],
      allShow: false,
      // 状态枚举值
      statusMap: {
        0: '未提交',
        1: '待审核', //待系统审核
        2: '待审核', //待提交官方
        3: '待审核', //待官方审核
        4: '拒绝',//系统拒绝
        5: '拒绝', //官方拒绝
        6: '通过',
      },
      pageInfo: {
        size: 10,
        current: 1,
      },
      total: 0,

      isShowAdd: false,
      controlType: "add",
      rowData: {},
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.tableLoading = true;
      try {
        const res = await getReportRecord({
          ...this.pageInfo
        })
        this.tableLoading = false;
        if (res.code == 1) {
          let list = res.data.records || []
          this.tableData = list;
          this.total = res.data.total;
        }else {
          this.$message.error(res.data.message)
        }
      } catch (err) {
        this.tableLoading = false;
      }
    },
    handlePageChange(info, type) {
      if (type == "size") this.pageInfo.size = info;
      if (type == "cur") this.pageInfo.current = info;
      this.getList()
    },
    onAddReport(row, type) {
      console.log("row>>", row);
      this.isShowAdd = true;
      this.controlType = type;
      this.rowData = row ? { ...row } : {};
    },

    onDelete(row) {
      let content = "删除后将不可恢复，是否确认删除？";
      this.$confirm(content, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            deleteReportRecord(row.id).then(res => {
              instance.confirmButtonLoading = false;
              if(res.code == 1) {
                done();
              } else {
                this.$message.error(res.data.message)
              }
            }).catch(err => {
              instance.confirmButtonLoading = false;
            })
          } else {
            done();
          }
        },
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getList();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.signature-report-real-container {
  background: #fff;
  height: 75vh;
  // background: #fff;
  border-radius: 0px 8px 8px 8px;
  padding: 0px 20px 16px;
  overflow-y: scroll;

  .head-box {
    //  padding: 24px;
    background: #fffaee;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px;
    overflow: hidden;
    font-size: 14px;
    color: #333333;
    margin-top: 20px;
    .head-icon {
      float: left;
      margin-right: 8px;
    }
    .head-content {
      float: left;
      width: 64%;
      line-height: 20px;
      position: relative;
      .icon_i {
        display: inline-block;
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        background-color: #ffb95e;
        color: #fff;
        font-size: 10px;
        font-weight: bold;
        text-align: center;
        line-height: 14px;
        font-weight: bold;
        top: 3px;
        left: 10px;
      }
      .block {
        width: 800px;
        display: block;
        margin-left: 29px;
      }
    }
  }

  .signature-report-real-content {
    margin-top: 16px;

    .new-table-box {
      margin-top: 16px;
      .header-row-tip {
        color: #2768ff;
        margin-left: 6px;
        cursor: pointer;
      }
    }
    .btn-box {
      display: flex;
      align-items: center;
      .btn-tip {
        color: red;
        margin-left: 10px;
      }
    }
  }
}
</style>
